import React from "react";
import "../css/Hero.css";

export default function Hero() {
  return (
    <section className="hero">
      <div className="hero-bg" />

      <div className="hero-wrapper">
        {/* INTRO */}
        <div className="hero-intro">
          <span className="hero-label">
            Inquizene • Software
          </span>

          <h1 className="hero-title">
            Thoughtfully Engineered <br />
            Software for <span>Growing Businesses</span>
          </h1>

          <p className="hero-lead">
            Inquizene is a technology startup focused on designing and building
            modern software systems that help businesses operate clearly,
            scale responsibly, and evolve with confidence.
          </p>
        </div>

        {/* GRID */}
        <div className="hero-grid">
          <div className="hero-column">
            <h3>What We’re Building</h3>
            <p>
              We create practical, well-architected software solutions that
              solve real operational problems without unnecessary complexity.
            </p>
            <ul>
              <li>Internal business applications</li>
              <li>Inventory & billing systems</li>
              <li>Modern web platforms</li>
              <li>APIs and system integrations</li>
            </ul>
          </div>

          <div className="hero-column">
            <h3>How We Think</h3>
            <p>
              As a startup, we focus on building software the right way from day
              one — clean, secure, and easy to grow.
            </p>
            <ul>
              <li>Simple, maintainable architectures</li>
              <li>Security and performance by default</li>
              <li>Clear data and predictable behavior</li>
              <li>Long-term mindset over quick hacks</li>
            </ul>
          </div>

          <div className="hero-column highlight">
            <h3>Why Work With Us</h3>
            <p>
              You work directly with engineers who care deeply about product
              quality, usability, and business outcomes.
            </p>

            <div className="hero-points">
              <div>Hands-on engineering team</div>
              <div>Transparent communication</div>
              <div>Flexible and adaptive approach</div>
              <div>Built to grow with your business</div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="hero-cta-bar">
          <div>
            <h4>Have an idea or problem to solve?</h4>
            <p>
              We’d love to understand your needs and see how we can help.
            </p>
          </div>

          <div className="hero-actions">
            <button className="btn-primary">Let’s Talk</button>
            <button className="btn-secondary">See What We Do</button>
          </div>
        </div>
      </div>
    </section>
  );
}
